export default __webpack_public_path__ + "beta-maps-guides-streets-1200-b639e94254fe0a0643b5dcdecaa7cb1a.webp";